import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal, ModalBody } from 'reactstrap';

export interface GalleryViewFile {
  type: string;
  source: string;
  id?: string | number;
}

export interface ModalViewGalleryHandle {
  open: (file: GalleryViewFile) => void;
  close: () => void;
}

export const modalViewGalleryRef = React.createRef<ModalViewGalleryHandle>();
const ModalViewGallery = forwardRef<ModalViewGalleryHandle, {}>(({ }, ref) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState<GalleryViewFile | null>(null);
  const onClose = () => setOpen(false);
  const toggle = () => setOpen(!open);

  useImperativeHandle(ref, () => ({
    open: (_file) => {
      setOpen(true);
      setFile(_file);
    },
    close: onClose
  }));

  return (
    <Modal modalClassName='gallery-modal' backdropClassName='gallery-modal-backdrop' isOpen={open} centered fade={false} toggle={toggle}>
      <ModalBody>
        <div className="main-media">
          {file && (
            file.type === 'video' ?
              <video src={file.source} autoPlay muted controls /> :
              <img src={file.source} />
          )}
        </div>
      </ModalBody>
      <button className='btn-close' onClick={onClose}><span>Close</span></button>
    </Modal>
  )
})
ModalViewGallery.displayName = 'ModalViewGallery';
export default ModalViewGallery;
